import Changed from './changed.svg';
import ClickedWithErrorDead from './clicked-with-error-dead.svg';
import ClickedWithErrorRage from './clicked-with-error-rage.svg';
import ClickedWithErrorSad from './clicked-with-error-sad.svg';
import ClickedWithError from './clicked-with-error.svg';
import Clicked from './clicked.svg';
import Clip from './clip.svg';
import ClipHover from './clip-hover.svg';
import ClipWatched from './clip-watched.svg';
import Pause from './pause.svg';
import Play from './play.svg';
import PlayOutline from './play-outline.svg';
import Quote from './quote.svg';
import Visited from './visited.svg';

export default {
  'playback/changed': Changed,
  'playback/clicked': Clicked,
  'playback/clicked-with-error': ClickedWithError,
  'playback/clicked-with-error-dead': ClickedWithErrorDead,
  'playback/clicked-with-error-rage': ClickedWithErrorRage,
  'playback/clicked-with-error-sad': ClickedWithErrorSad,
  'playback/clip': Clip,
  'playback/clip-hover': ClipHover,
  'playback/clip-watched': ClipWatched,
  'playback/pause': Pause,
  'playback/play': Play,
  'playback/play-outline': PlayOutline,
  'playback/quote': Quote,
  'playback/visited': Visited,
};
